// @flow

import Formatic from 'formatic';
import PropTypes from 'prop-types';
import PureRenderMixin from 'react-addons-pure-render-mixin';
import React from 'react';
import _ from 'lodash';
import createReactClass from 'create-react-class'; // eslint-disable-line no-restricted-syntax

import FilterGroups from 'app/beta-editor/components/formatic/FilterGroups';
import RuleUtils from 'app/beta-editor/utils/RuleUtils';

const createRule = group => ({
  action: 'continue',
  group: _.isNumber(group) ? group : RuleUtils.createId(),
  id: RuleUtils.createId(),
  key: null,
  match: null,
  value: null,
});

const Filter = createReactClass({
  displayName: 'Filter',

  mixins: [PureRenderMixin, Formatic.availableMixins.field],

  propTypes: {
    config: PropTypes.object.isRequired,
    field: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
  },

  componentDidMount() {
    if (!this.getRules().length) {
      this.onAddGroup();
    }
  },

  getRules() {
    return this.props.field.value || [];
  },

  onChangeRule(ruleId, value, key, info) {
    const rules = this.getRules();
    const newRules = rules.map(rule =>
      rule.id !== ruleId
        ? rule
        : RuleUtils.toServerRule({
            ...rule,
            // Always send in `match` as UI-formatted because if
            // we don't explicitly supply it in UI format, `toServerRule`
            // can't accurately convert it to server format because it
            // doesn't have enough information...
            match: RuleUtils.toUiMatch(rule),
            // ...then send in `[key]: value` *after* which will
            // override `match` if `key === 'match'`.
            [key]: value,
          })
    );
    this.props.onChange(newRules, info);
  },

  onAction(info) {
    this.onBubbleAction(info);
  },

  onAddGroup() {
    const rules = this.getRules();
    const newGroupId = RuleUtils.createId();
    const newRules = [...rules, createRule(newGroupId)];
    this.onChangeValue(newRules);
  },

  onAddRule(groupId) {
    const rules = this.getRules();
    const lastIdx = _.findLastIndex(rules, rule => rule.group === groupId);
    const insertionIdx = Math.max(0, lastIdx) + 1;
    const newRules = [...rules];
    newRules.splice(insertionIdx, 0, createRule(groupId));
    this.onChangeValue(newRules);
  },

  onDeleteRule(ruleId) {
    const rules = this.getRules();
    const newRules = _.reject(rules, rule => rule.id === ruleId);
    this.onChangeValue(newRules);
  },

  render() {
    return this.renderWithConfig();
  },

  renderDefault() {
    const { props } = this;
    const grouped = RuleUtils.ruleGroups(props.field.value);
    const groups = Object.keys(grouped).map(groupId => ({
      groupId: parseInt(groupId, 10),
      rules: (grouped[groupId] || []).map(RuleUtils.toUiRule),
    }));
    const filterGroups = (
      <FilterGroups
        config={this.props.config}
        field={this.props.field}
        groups={groups}
        onAction={this.onAction}
        onAddGroup={this.onAddGroup}
        onAddRule={this.onAddRule}
        onChangeRule={this.onChangeRule}
        onDeleteRule={this.onDeleteRule}
      />
    );
    return props.config.createElement(
      'field',
      {
        field: props.field,
        id: `${props.field.label}-${props.field.fieldIndex}`,
      },
      filterGroups
    );
  },
});

export default Filter;
